import { MKT } from 'src/sections/@dashboard/marketing/marketing.design';

// Visual editorial — alinhado ao Painel de Métricas, sem icon-box shadcn.
export const MKT_CTWA_DESIGN = {
    ...MKT,
    page: {
        ...MKT.page,
        root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
        fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
        container: 'w-full px-4 md:px-6 lg:px-8',
        pageBody: 'pb-[120px]',
        stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
        topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
        topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
        iconTileWhatsapp:
            'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ecfdf3] text-[#067647]',
        headerTitle: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
        headerSubtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
        filterBar: 'flex flex-wrap items-end gap-3 mb-3',
        filterItem: 'min-w-0',
        filterLabel: 'text-[10px] font-semibold text-[#a1a1aa] uppercase tracking-wider mb-1 block',
        filterSelect:
            'h-9 w-[150px] md:w-[170px] text-xs rounded-lg border border-[#d4d4d8] bg-white px-3 text-[#18181b] shadow-none hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',
        periodHint: 'text-[13px] font-medium text-[#71717a] mb-5',
    },
    statsGrid: 'grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#e6e6ec] border border-[#e6e6ec] rounded-xl overflow-hidden',
    statCell: 'bg-white px-4 py-3.5',
    statVal: 'text-[22px] font-extrabold tracking-[-0.02em] tabular-nums text-[#17172b]',
    statLbl: 'text-[11px] font-bold uppercase tracking-wider text-[#8b8b9a] mt-0.5',
    section: {
        wrapper: 'bg-white border border-[#e6e6ec] rounded-xl p-5 md:p-6',
        headerRow: 'flex items-end justify-between gap-3 mb-4 flex-wrap',
        title: 'text-[15px] font-extrabold tracking-[-0.01em] text-[#17172b]',
        subtitle: 'text-[12px] font-medium text-[#6b6b7b] mt-1',
    },
    insight: 'text-[13px] font-medium text-[#6b6b7b] leading-relaxed px-1',
    filterBar: 'flex items-center gap-1 flex-wrap',
    filterTab: 'px-3 py-1.5 text-[12px] font-semibold rounded-md transition-colors text-[#6b6b7b] hover:text-[#17172b] hover:bg-[#f4f4f6]',
    filterTabActive: 'bg-[#17172b] text-white hover:bg-[#17172b] hover:text-white',
    viewToggle: 'flex border border-[#e6e6ec] rounded-md overflow-hidden',
    viewBtn: 'px-2.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-[#6b6b7b] hover:bg-[#f4f4f6] transition-colors',
    viewBtnActive: 'bg-[#f4f4f6] text-[#17172b]',
    recentRow: 'flex items-baseline gap-3 py-2.5 border-b border-[#f3f3f6] last:border-0 text-[13px]',
    adGrid: 'grid grid-cols-1 lg:grid-cols-2 gap-3',
    adCard: 'flex gap-3 p-3.5 bg-white border border-[#e6e6ec] rounded-xl transition-colors',
    adCardClickable: 'cursor-pointer hover:border-[#6d28d9] hover:shadow-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6d28d9]/30',
    adMain: 'flex-1 min-w-0 flex flex-col gap-2',
    adTop: 'flex gap-4 justify-between items-start',
    adRankLine: 'flex items-center gap-1.5 flex-wrap mb-1',
    adRank: 'text-[11px] font-extrabold text-[#8b8b9a] tabular-nums',
    adPlatform: 'text-[11px] font-bold uppercase tracking-wide',
    adMuted: 'text-[11px] font-medium text-[#a0a0af]',
    adHeadline: 'text-[14px] font-bold text-[#17172b] leading-snug line-clamp-2',
    adCopy: 'text-[12px] text-[#6b6b7b] leading-relaxed line-clamp-2 mt-0.5',
    adMetrics: 'flex gap-4 flex-shrink-0 text-right',
    adMetricVal: 'block text-[18px] font-extrabold tabular-nums text-[#17172b] leading-none',
    adMetricLbl: 'block text-[10px] font-bold uppercase tracking-wide text-[#a0a0af] mt-0.5',
    adBarTrack: 'h-[3px] bg-[#f2f2f5] rounded-full overflow-hidden',
    adBarFill: 'h-full bg-[#6d28d9] rounded-full',
    adFooter: 'flex items-center justify-between gap-2',
    adId: 'text-[10px] font-mono text-[#a0a0af] truncate',
    adLastContact: 'text-[10px] font-medium text-[#8b8b9a] mt-0.5 truncate',
    adLink: 'text-[11px] font-bold text-[#6d28d9] hover:underline flex-shrink-0',
    listWrap: 'border border-[#e6e6ec] rounded-xl overflow-x-auto bg-white',
    listRow: 'flex items-center gap-3 px-4 py-3 border-b border-[#f3f3f6] last:border-0 hover:bg-[#fafafb] transition-colors min-w-[720px]',
    listHead: 'bg-[#fafafb] text-[10px] font-extrabold uppercase tracking-wider text-[#8b8b9a] py-2.5 hover:bg-[#fafafb]',
    listHeadCell: 'flex-shrink-0 whitespace-nowrap',
    listRank: 'w-7 min-w-[1.75rem] flex-shrink-0 text-[11px] font-bold text-[#a0a0af] tabular-nums text-center',
    listThumb: 'w-11 min-w-[2.75rem] flex-shrink-0',
    listAdCol: 'flex-1 min-w-[140px] pr-3',
    listTitle: 'text-[13px] font-bold text-[#17172b] truncate',
    listSub: 'text-[11px] text-[#8b8b9a] truncate mt-0.5',
    listColPlat: 'w-24 min-w-[6rem] flex-shrink-0 text-[11px] font-bold uppercase tracking-wide hidden md:block',
    listColNum: 'w-[4.75rem] min-w-[4.75rem] flex-shrink-0 text-right text-[13px] hidden sm:block tabular-nums',
    listColDate: 'w-[6.5rem] min-w-[6.5rem] flex-shrink-0 text-right text-[11px] text-[#8b8b9a] hidden lg:block tabular-nums whitespace-nowrap',
    listColAction: 'w-10 min-w-[2.5rem] flex-shrink-0 text-right',
    listBarTrack: 'h-[2px] bg-[#f2f2f5] rounded-full mt-1.5 max-w-[200px]',
    listBarFill: 'h-full bg-[#6d28d9] rounded-full',
    chatDrawerRow: 'flex items-center gap-3 w-full py-3 border-b border-[#f3f3f6] last:border-0 text-left transition-colors',
    chartRow: 'grid grid-cols-1 xl:grid-cols-[1fr_260px] gap-4 items-stretch',
    wabaHero: {
        wrap: 'flex flex-col items-center justify-center min-h-[calc(100vh-220px)] py-10',
        card: 'w-full max-w-md bg-white border border-[#e6e6ec] rounded-2xl px-8 py-12 flex flex-col items-center text-center',
        iconBox: 'w-14 h-14 rounded-2xl bg-[#25D366]/10 flex items-center justify-center mb-4',
        title: 'text-lg font-extrabold text-[#17172b] tracking-tight',
        subtitle: 'text-sm text-[#6b6b7b] mt-2 leading-relaxed',
        cta: 'mt-6 h-10 px-5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-semibold rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:scale-95',
    },
};
